import { PredictionRequest, PredictionRequestSchema } from "@portal-frontend-ssr/blast-api";
import { BountyStage } from "../providers/BountyCalculator";

export const mapStagesToShareablePrediction = (stages: BountyStage[]): PredictionRequest => {
  return PredictionRequestSchema.parse({
    stages: stages.map((stage) => {
      return {
        stageId: stage.stageId,
        matches: stage.matches.map((match) => {
          return {
            matchId: match.id,
            teamAId: match.teamA?.id,
            teamBId: match.teamB?.id,
            winnerTeamId: match.winnerTeamId,
          };
        }),
      };
    }),
  });
};
